import axiosClient from "utils/api";
const URI = "/admin/checkIn";

export const getUserCheckIn = async (payload) => {
  const { id, ...rest } = payload;
  const URL = `${URI}/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during Get user check in:", error);
    throw error;
  }
};

export const getUserCheckInSummary = async (payload) => {
  const { id, ...rest } = payload;
  const URL = `${URI}/summary/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during Get user check in summary:", error);
    throw error;
  }
};

export const getUserCheckInHistory = async (payload) => {
  const { id, ...rest } = payload;
  const URL = `${URI}/history/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during Get user check in history:", error);
    throw error;
  }
};
